import { AlertCircle, CheckCircle } from "lucide-react";

const VerificationStatusItem = ({ label, verified }) => (
    <div className="flex items-center justify-between text-sm">
        <span className="text-green-100">{label}</span>
        {verified ? (
            <CheckCircle className="w-4 h-4 text-green-300" />
        ) : (
            <AlertCircle className="w-4 h-4 text-yellow-300" />
        )}
    </div>
);

export default VerificationStatusItem;